export default function TextFilter() {}
TextFilter.prototype.init = function (params) {
  this.valueGetter = params.valueGetter;
  this.filterText = null;
  this.params = params;
  this.setupGui();
};
TextFilter.prototype.setupGui = function () {
  // only for filter purpose, not printed in view
  this.gui = document.createElement('input');
  let that = this;
  this.onChangeFilter = function () {
    that.extractFilterText();
    that.params.filterChangedCallback();
  };
  this.eFilterText = this.gui;
  this.eFilterText.addEventListener('input', this.onChangeFilter);
};
TextFilter.prototype.extractFilterText = function () {
  this.filterText = this.eFilterText.value;
};
TextFilter.prototype.doesFilterPass = function (params) {
  if (params.data.skipFromFilter) return true;
  let valueGetter = this.valueGetter;
  let value = valueGetter(params);
  let filterValue = this.filterText;
  if (this.isFilterActive()) {
    var _this$params, _this$params$colDef, _this$params2, _this$params2$colDef;
    if (!value) return false;
    const columnParameters = ((_this$params = this.params) === null || _this$params === void 0 ? void 0 : (_this$params$colDef = _this$params.colDef) === null || _this$params$colDef === void 0 ? void 0 : _this$params$colDef.filterParams) || ((_this$params2 = this.params) === null || _this$params2 === void 0 ? void 0 : (_this$params2$colDef = _this$params2.colDef) === null || _this$params2$colDef === void 0 ? void 0 : _this$params2$colDef.floatingFilterComponentParams);
    if ((columnParameters === null || columnParameters === void 0 ? void 0 : columnParameters.caseSensitive) === false) {
      value = value.toLowerCase();
      filterValue = filterValue.toLowerCase();
    }
    const filter = (columnParameters === null || columnParameters === void 0 ? void 0 : columnParameters.filter) || 'contains';
    switch (filter) {
      case 'contains':
        return value.indexOf(filterValue) >= 0;
      case 'notContains':
        return value.indexOf(filterValue) === -1;
      case 'equals':
        return value === filterValue;
      case 'notEqual':
        return value !== filterValue;
      case 'startsWith':
        return value.indexOf(filterValue) === 0;
      case 'endsWith':
        let index = value.lastIndexOf(filterValue);
        return index >= 0 && index === value.length - filterValue.length;
      default:
        // should never happen
        console.warn('invalid filter type ' + filter);
        return false;
    }
  }
};
TextFilter.prototype.isFilterActive = function () {
  return this.filterText !== null && this.filterText !== undefined && this.filterText !== '';
};
TextFilter.prototype.getModel = function () {
  return this.isFilterActive() ? {
    filter: this.eFilterText.value
  } : null;
};
TextFilter.prototype.setModel = function (model) {
  this.eFilterText.value = model;
  this.extractFilterText();
};
TextFilter.prototype.onCustomFilterChanged = function (value) {
  this.eFilterText.value = value;
  this.onChangeFilter();
};
TextFilter.prototype.destroy = function () {
  this.eFilterText.removeEventListener('input', this.onChangeFilter);
};
TextFilter.prototype.getGui = function () {
  return this.gui;
};